import React from "react";
import { arc, scaleLinear } from "d3";

interface GaugeNationalPointProps {
    value: number;
}

export const GaugeNationalPoint = (props: GaugeNationalPointProps) => {
    const { value } = props;

    const percentScale = scaleLinear().domain([0, 100]).range([0, 1]);

    const percent = value => percentScale(value);

    const angleScale = scaleLinear()
        .domain([0, 1])
        .range([-Math.PI / 2, Math.PI / 2])
        .clamp(true);

    const nationalAngle = angleScale(percent(value));

    const nationalPoint = arc()
        .innerRadius(0.8)
        .outerRadius(1.05)
        .startAngle(nationalAngle)
        .endAngle(nationalAngle + 0.01);

    return <path d={nationalPoint(null)} fill="#210071" />;
};
